// ##### 24-06-14 Komarov
import uniqueId from 'lodash.uniqueid';
import moment from 'moment';
// ##### Komarov 2025-07-23
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
// ##### 25-05-21 Komarov
import MinRate from '../MinRate';
// ##### 24-12-26 Komarov
import { makeParamsString } from '../../../Helpers/helper';

// ##### Komarov 2025-07-23
const DivTag = ({ className, tariff, tour_name, pickedCurrency }) => {
  // ##### Komarov 2025-08-05
  const ViewDetailsButton = useSelector(state => state.pagesRedux[state.language]?.ViewDetailsButton || '');

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  const location = useLocation();
  const history = useHistory();

  //фильтрую объект с тарифами, датами так, чтобы вывести первую встречающую дату каждого вида (к примеру, у меня пришло
  //в массиве 10 раз дата 2021-03-03, 3 раза дата 2021-03-04, 4 раза дата 2021-03-05 - я вывожу новый массив, где будет
  //объект в массиве, где первый раз встречается 2021-03-03, потом объект, где встречается 2021-03-04 первый раз, и т.д.)
  //это нужно, чтобы вывести список периодов для выбора
  const filtered_tour_dates = tariff.rate.filter(
    (item1, index, array) =>
      array.findIndex(t => t.date === item1.date) === index
  );

  // console.log('[FILTERED_TOUR_DATES] : ' , filtered_tour_dates)
  const [selection, setSelection] = useState(filtered_tour_dates[0].date);
  const [detailsList, setDetailsList] = useState([]);
  function selectedPeriod(e) {
    setSelection(e.target.value);
  }

  const addToDetails = e => {
    e.preventDefault();

    const outline = {
      id: tariff.tour_id,
      date: selection,
    };

    setDetailsList([outline]);
    // console.log('TEST TEST', e.view.history)
    // console.log('[DETAILS LIST] : ' , detailsList)
    // ##### 23-11-09 Komarov
    // const route_query = `${location.search},tour_name=${tour_name},tour_id=${tariff.tour_id},selection=${selection}`
    // ##### 24-12-26 Komarov
    // const route_query = `${location.search}&tour_name=${tour_name}&tour_id=${tariff.tour_id}&selection=${selection}`;
    const params_string = makeParamsString({
      tour_name: tour_name,
      tour_id: tariff.tour_id,
      selection: selection,
    });
    const route_query = `${location.search}&${params_string}`;
    history.push(`/${locale}/tour_details/${route_query}`, [
      ...detailsList,
      outline,
    ]);
  };

  return (
    <div className={className} data-component="DivTag">
      <div className="availablePeriods">
        <div style={{ fontSize: '2vh', fontWeight: 'bold' }}>
          Available dates :{' '}
        </div>
        <select
          value={selection}
          onChange={selectedPeriod}
          style={{ fontSize: '2vh', color: '#001959' }}
        >
          <>
            {
              // ##### 24-03-21 Komarov
              filtered_tour_dates?.map(filter => {
                return (
                  <option
                    value={filter.date}
                    //  ##### 23-04-12 Komarov
                    key={uniqueId()}
                  >
                    {filter.date} --{' '}
                    {moment(filter.date)
                      .add(tariff.duration, 'days')
                      .format('YYYY-MM-DD')}{' '}
                    ({tariff.duration} days)
                  </option>
                );
              })
            }
          </>
        </select>
      </div>

      <div className="minimumRate">
        <div style={{ fontSize: '10px', color: 'grey', fontStyle: 'italic' }}>
          {selection}
        </div>
        <MinRate
          selection={selection}
          datesArray={tariff.rate}
          pickedCurrency={pickedCurrency}
        />
        <button
          // ##### 24-03-21 Komarov
          type="submit"
          className="availableButtonSecondPage"
          onClick={addToDetails}
        >
          {
            // ##### 23-10-04 Komarov
            ViewDetailsButton
          }
        </button>
        <div style={{ fontSize: '10px', color: 'grey', fontStyle: 'italic' }}>
          {tariff.tour_id}
        </div>
      </div>
    </div>
  );
};

export default DivTag;
